export default class AbstractModel {
    constructor(name, modelConfig) {
        this.name = name
        for(let property in modelConfig) {
            this[property] = modelConfig[property]
        }
    }
}